import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PwaActivityService {
  private operations = 0;
  private lastOperationFinishedAt = Date.now();
  navigating = false;

  get busy(): boolean {
    return this.operations > 0 || this.navigating;
  }

  get recentlyBusy(): boolean {
    return Date.now() - this.lastOperationFinishedAt < 2000;
  }

  beginOperation(): () => void {
    this.operations++;
    let finished = false;

    return () => {
      if (finished) return;
      finished = true;
      this.operations--;
      this.lastOperationFinishedAt = Date.now();
    };
  }
}
